import type { HttpErrorResponse } from '@angular/common/http';
import type { RouterStateSnapshot } from '@angular/router';
import { of } from 'rxjs';

import type { IHttpErrorHandlerService } from 'src/services/http-error-handler/entities/types';

import type { ILandingPage } from '../layouts/entities/types';

export class BaseResolver {
    private readonly urlCheckRegex = /%2F|\.\./g;

    constructor(protected readonly httpErrorHandlerService: IHttpErrorHandlerService) {}

    protected isUrlPathCorrect(state: RouterStateSnapshot) {
        const pathname = state.url.split('?')[0].toUpperCase();
        return !this.urlCheckRegex.test(pathname);
    }

    protected handleSuccess(data: ILandingPage) {
        this.httpErrorHandlerService.resetError();
        return of(data);
    }

    protected handleError(error: HttpErrorResponse) {
        this.httpErrorHandlerService.setHttpStatus(error.status);
        return of(null);
    }
}
